var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_6949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.416992 18.75H4.58366C5.02569 18.75 5.44961 18.5744 5.76217 18.2618C6.07473 17.9493 6.25033 17.5254 6.25033 17.0833V15.4167C6.25033 14.9746 6.07473 14.5507 5.76217 14.2382C5.44961 13.9256 5.02569 13.75 4.58366 13.75H0.416992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 18.75H18.333C19.2497 18.75 19.583 18.0042 19.583 17.0833V15.4167C19.583 14.5 19.2497 13.75 18.333 13.75H4.58301",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.75V18.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.583 13.75V18.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75V18.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58301 13.75V18.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 17.083H1.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 15.417H1.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 13.75V12.8067C12.5 12.7222 12.4742 12.6397 12.4261 12.5702C12.378 12.5007 12.31 12.4474 12.2309 12.4175C11.6628 12.2047 11.1789 11.8135 10.8518 11.3026C10.5247 10.7916 10.3721 10.1884 10.4168 9.58333C10.4168 6.71333 13.6451 10.2992 13.7501 1.67833C13.7512 1.56641 13.708 1.45857 13.63 1.37834C13.5519 1.2981 13.4453 1.25197 13.3334 1.25H5.83759C5.72567 1.25197 5.61907 1.2981 5.54102 1.37834C5.46297 1.45857 5.4198 1.56641 5.42092 1.67833C5.52342 10.2992 8.75425 6.71333 8.75425 9.58333C8.79873 10.1882 8.64599 10.7913 8.31893 11.3021C7.99187 11.8129 7.50809 12.2039 6.94009 12.4167C6.86014 12.446 6.79108 12.499 6.74221 12.5688C6.69334 12.6385 6.66701 12.7215 6.66675 12.8067V13.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41664 2.08301H3.77414C3.71581 2.08273 3.65807 2.0947 3.60466 2.11815C3.55125 2.14159 3.50336 2.17599 3.46408 2.21911C3.42481 2.26224 3.39502 2.31313 3.37666 2.3685C3.35829 2.42386 3.35176 2.48246 3.35747 2.54051C3.45497 3.62385 3.70331 6.24968 6.01914 6.24968",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.08301H15.3925C15.4508 2.08273 15.5085 2.0947 15.5619 2.11815C15.6154 2.14159 15.6632 2.17599 15.7025 2.21911C15.7418 2.26224 15.7716 2.31313 15.7899 2.3685C15.8083 2.42386 15.8148 2.48246 15.8091 2.54051C15.7116 3.62385 15.4641 6.24968 13.1475 6.24968",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_6949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompet);
export default __webpack_public_path__ + "static/media/compet.0f400f3a560d172daee2c5c41a520cde.svg";
export { ForwardRef as ReactComponent };